import React, { useEffect, useState } from 'react'


const alphabet = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];

let checkResponse = false
export const GameQuestionActivityThree = ({
	data = {
		question: "",
		img: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: "",
				isCorrect: true
			},
			{
				id: 3,
				text: ""
			},
		]
	},
	actionGameQuestion = () => {

	} }) => {
	const [selectAnswer, setSelectAnswer] = useState(-1)
	const [isNextQuestion, setIsNextQuestion] = useState(false)
	const [statusResponse, setStatusResponse] = useState(0)

	const setSelectQuestion = (id) => {
		const questionIsCorrect = data.options.find((opt) => opt.id === id)
		if (!questionIsCorrect) {
			return
		}
		if (checkResponse) {
			return
		}
		checkResponse = true
		if (questionIsCorrect.isCorrect) {
			setStatusResponse(1)
		} else {
			setStatusResponse(2)
		}
		setSelectAnswer(id)
		setIsNextQuestion(true)
	}

	const nextQuestion = () => {
		checkResponse = false
		actionGameQuestion(statusResponse)
		setSelectAnswer(-1)
		setStatusResponse(0)
		setIsNextQuestion(false)
	}

	useEffect(() => {
		let time = null
		if (isNextQuestion) {
			setTimeout(() => {
				nextQuestion()
			}, 1000);
		}
		return () => {
			clearTimeout(time)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isNextQuestion])

	return (
		<>
			<div className='fixed z-20 w-full h-full bottom-0 animate__animated  animate__fadeIn'>
				<div className="h-full w-full">
					<div className="w-full h-[calc(100%-100px)] md:h-[calc(100%-200px)] flex justify-center items-end">
						<div className='h-full w-full flex justify-center items-center'>
							<div className='h-[250px] md:h-[410px] w-[250px] md:w-[410px] '>
								<img className='h-full w-full object-contain' src={data.img} alt="images" />
							</div>
						</div>
					</div>
					<div className="w-full h-[100px] md:h-[200px] px-[48px] md:px-[116px]">
						<div className='w-full gradiantBlueClient p-2 md:p-4 rounded-[24px] h-[95px] md:h-[150px] overflow-hidden'>
							<div className="w-full h-[24px] md:h-[40px] bg-red_primary rounded-tl-3xl rounded-tr-3xl flex justify-center items-center mb-2 md:mb-4">
								<p className="text-white text-[14px] md:text-[16px] md:font-semibold">{data.question}</p>
							</div>
							<div className='h-[calc(100%-34px)] md:h-[calc(100%-55px)] w-full flex gap-2'>
								{data.options.map((question, index) => (
									<OptionsQuestion
										key={`${index}-questionGame`}
										indexLetter={index}
										selectAnswer={selectAnswer}
										typeResponse={statusResponse}
										action={setSelectQuestion}
										text={question.text} id={question.id} />
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

const OptionsQuestion = ({ indexLetter = 0, selectAnswer = -1, action = () => { }, text = "", id = 0, typeResponse = 0 }) => {
	let styleQuestion = { back: "bg-white", colorText: "text-black", colorLetter: "text-red_primary" }

	if (typeResponse === 1 && id === selectAnswer) {
		styleQuestion = { back: "bg-[#22C55E]", colorText: "text-white", colorLetter: "text-white" }
	}
	if (typeResponse === 2 && id === selectAnswer) {
		styleQuestion = { back: "bg-[#DF3C3C]", colorText: "text-white", colorLetter: "text-white" }
	}
	return (
		<>
			<div onClick={() => { action(id) }} className={`${styleQuestion.back} w-full rounded-2xl flex items-center p-2 md:gap-4`}  >
				<div className="w-[20px] ">
					<p className={`${styleQuestion.colorLetter} font-bold text-[12px] md:text-[20px]`}>{alphabet[indexLetter]})</p>
				</div>
				<div className="w-[cacl(100%-20px)] overflow-hidden">
					<p className={`${styleQuestion.colorText} text-[10px] md:text-[14px]`}>{text}</p>
				</div>
			</div>
		</>
	)
}
